module.exports = FFmpegWASM;